export default __webpack_public_path__ + "static/media/fhpCoinToken.2e1a35fa.jpg";